import type { Func } from '@ricoh/ria.client.core/types/core/function.type';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import type { FieldValidConfidenceSchemaCreator } from './_ocr.type';

/**
 * Use Field ValidConfidence Schema Creator.
 *
 * @returns {FieldValidConfidenceSchemaCreator} Field ValidConfidence Schema Creator.
 */
export function useFieldValidConfidenceSchemaCreator(): FieldValidConfidenceSchemaCreator {
  const { t } = useTranslation();

  const createErrorMap = useCallback<Func<[fieldName: string], z.ZodErrorMap>>(
    (fieldName) => (issue) => {
      if (issue.code === 'invalid_literal') {
        return {
          message: t(`feature:process.batch.message.invalidConfidence`),
        };
      }

      return {
        message: t('validation:invalidType', { fieldName }),
      };
    },
    [t],
  );

  return useCallback<FieldValidConfidenceSchemaCreator>(
    ({ fieldName }) =>
      z.literal(true, {
        errorMap: createErrorMap(fieldName),
      }),
    [createErrorMap],
  );
}
